var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2891_50017)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.17187 14.9409V8.11816C1.17187 7.79455 1.43422 7.53223 1.75781 7.53223H18.2422C18.5658 7.53223 18.8281 7.79455 18.8281 8.11816V14.941C18.384 15.4388 17.7143 15.7354 17.0312 15.7354C16.2936 15.7354 15.5989 15.388 15.1562 14.7978L14.6875 14.1729L14.2187 14.7979C13.7762 15.388 13.0815 15.7354 12.3438 15.7354C11.6061 15.7354 10.9114 15.388 10.4687 14.7978L9.99997 14.1729L9.53124 14.7979C9.08866 15.388 8.39401 15.7354 7.65625 15.7354C6.91858 15.7354 6.22391 15.388 5.78124 14.7978L5.31247 14.1729L4.84374 14.7979C4.40116 15.388 3.70651 15.7354 2.96875 15.7354C2.28578 15.7354 1.61606 15.4388 1.17187 14.9409ZM0.117202 15.501C0.786121 16.3928 1.87061 16.9072 2.96875 16.9072C3.84144 16.9072 4.67395 16.5832 5.31252 16.012C5.95112 16.5832 6.7836 16.9072 7.65625 16.9072C8.52894 16.9072 9.36145 16.5832 10 16.012C10.6386 16.5832 11.4711 16.9072 12.3438 16.9072C13.2164 16.9072 14.0489 16.5832 14.6875 16.012C15.3261 16.5832 16.1586 16.9072 17.0312 16.9072C18.1294 16.9072 19.214 16.3928 19.8828 15.501L20 15.3447V8.11816C20 7.14732 19.213 6.36035 18.2422 6.36035H1.75781C0.787033 6.36035 0 7.14732 0 8.11816V15.3447L0.117202 15.501Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.38281 3.43066C2.38281 4.40151 3.16985 5.18848 4.14062 5.18848C5.1114 5.18848 5.89844 4.40151 5.89844 3.43066V0.500977H2.38281V3.43066ZM4.14062 4.0166C3.81703 4.0166 3.55469 3.75427 3.55469 3.43066V1.67285H4.72656V3.43066C4.72656 3.75427 4.46422 4.0166 4.14062 4.0166Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.72656 6.94629V4.60254H3.55469V6.94629H4.72656Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1016 3.43066C14.1016 4.40151 14.8886 5.18848 15.8594 5.18848C16.8302 5.18848 17.6172 4.40151 17.6172 3.43066V0.500977H14.1016V3.43066ZM15.8594 4.0166C15.5358 4.0166 15.2734 3.75427 15.2734 3.43066V1.67285H16.4453V3.43066C16.4453 3.75427 16.183 4.0166 15.8594 4.0166Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4453 6.94629V4.60254H15.2734V6.94629H16.4453Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.84473C7.73475 2.84473 5.89844 4.68104 5.89844 6.94629H7.07031C7.07031 5.32825 8.38196 4.0166 10 4.0166C11.618 4.0166 12.9297 5.32825 12.9297 6.94629H14.1016C14.1016 4.68104 12.2652 2.84473 10 2.84473Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5859 3.43066V1.67285H9.41406V3.43066H10.5859Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4141 8.7041H0.585937V9.87598H19.4141V8.7041Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.24219 20.501H11.7578V16.0767H10.5859V19.3291H9.41406V16.0767H8.24219V20.501Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.82809 19.3291H5.89844V20.501H8.82809V19.3291Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1016 19.3291H11.1719V20.501H14.1016V19.3291Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2891_50017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg16);
export default __webpack_public_path__ + "static/media/16.c4dfbd7c288b82abe46633141f92921b.svg";
export { ForwardRef as ReactComponent };